import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ResizeService } from '@df/ui/common/resize.service';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { AkamaiResizeService } from './akamai-resize.service';
import { NAkamai } from './akamai.interface';

export function provideDfModuleAkamai(config?: Partial<NAkamai.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: ResizeService, useClass: AkamaiResizeService },
        {
            provide: NAkamai.OPTIONS,
            useFactory: () => defaultsDeep(config, NAkamai.DEFAULT_OPTIONS)
        }
    ]);
}
